import React, { ReactElement } from 'react'
import { StickyContainer } from 'react-sticky'
import styled from 'styled-components/macro'
import { Layout } from './Layout'
import { Header } from './Header'

const StickyWrapper = styled(StickyContainer)`
  flex: 1 1 auto;
  margin-top: 40px;
  padding-bottom: 40px;
  padding-top: 20px;
`

type Props = {
  children: ReactElement<typeof Layout>
}

export const Page = ({ children }: Props) => (
  <>
    <Header />
    <StickyWrapper>{children}</StickyWrapper>
  </>
)
